import { render, staticRenderFns } from "./ChangeStorageLocationModal.vue?vue&type=template&id=5ab82025&scoped=true"
import script from "./ChangeStorageLocationModal.vue?vue&type=script&lang=js"
export * from "./ChangeStorageLocationModal.vue?vue&type=script&lang=js"
import style0 from "./ChangeStorageLocationModal.vue?vue&type=style&index=0&id=5ab82025&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab82025",
  null
  
)

export default component.exports